import { Controller } from "@hotwired/stimulus"
import { formatNumericInput } from "../../utils/form_details"

export default class extends Controller {
  static targets = ["blikCodeInput"]

  get blikCodeInput() {
    return this.blikCodeInputTarget
  }

  formatBlikCode() {
    const target = this.blikCodeInput
    formatNumericInput(target, (number) => number.match(/.{1,3}/g)?.join(" "))
  }
}
